class FirehawkCheckout {

	cartId = null
	checkoutWrapper = null;
	addressAutoComplete = null;

	paymentIntent = null;
	paymentElement = null;
	elements = null;

	formElement = null
	isSubmitting = false
	paymentFormComplete = false
	countries = null;

	stripePublishableKey = null;

	paymentMethod = null
  loadingStripe = true
  hasInitialStripe = false

	constructor(cartId, element, countries = null, sPublishableKey = null) {
		this.countries = countries;
		this.cartId = cartId && cartId.length ? cartId : null
		this.checkoutWrapper = element
		this.formElement = jQuery(this.checkoutWrapper).find("form")
		this.stripePublishableKey = sPublishableKey;
		this.addListeners()
		this.setupGoogleAddress();
		this.setupStripe();
	}

	addListeners() {

		jQuery(this.checkoutWrapper).delegate("#submit-order", 'click', (event) => {
			event.preventDefault()
			// let formValid = this.validateForm();
			// if(formValid) {
			this.submitOrder();
			// }
		});

		this.formElement.validate({
			// Specify validation rules
			rules: {
				// The key name on the left side is the name attribute
				// of an input field. Validation rules are defined
				// on the right side
				shippingFirstName: {
					required: true
				},
				shippingLastName: {
					required: true
				},
				shippingStreet: {
					required: true
				},
				shippingCity: {
					required: true
				},
				shippingState: {
					required: true
				},
				shippingPostcode: {
					required: true
				},
				shippingEmail: {
					required: true,
					email: true
				}
			},
			// Specify validation error messages
			messages: {
				shippingFirstName: "Please enter your first name",
				shippingLastName: "Please enter your last name",
				shippingStreet: "Please enter in a street address",
				shippingCity: "Please enter in a city",
				shippingState: "Please enter in a state",
				shippingPostcode: "Please enter in a zip code",
				shippingEmail: "Please enter a valid email address"
			},
			// Make sure the form is submitted to the destination defined
			// in the "action" attribute of the form when valid
			// submitHandler: function(form) {
			//   form.submit();
			// }
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=shippingOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updateShippingMethod(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=paymentOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updatePaymentMethod(optionSelected);
		});

    var paymentOption = jQuery(this.checkoutWrapper).find("input[type=radio][name=paymentOption]:checked")
    this.updatePaymentMethod(paymentOption.val())

		jQuery(this.checkoutWrapper).delegate("select[name=shippingCountry]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();

			if (optionSelected && optionSelected.length) {
				let foundCountry = this.countries.find((c) => c && c.name == optionSelected)

				if (foundCountry && foundCountry["alpha-2"] && this.addressAutoComplete) {
					this.addressAutoComplete.setComponentRestrictions({
						'country': foundCountry["alpha-2"]
					})
				} else if (this.addressAutoComplete) {
					this.addressAutoComplete.setComponentRestrictions({
						'country': null
					})
				}

				jQuery.ajax({
					method: 'post',
					url: ajax_var.url,
					data: {
						action: 'fh_fetch_states',
						params: {
							country: foundCountry.id || null
						}
					}
				}).done((res) => {
					let response = JSON.parse(res);

					let pickerField = jQuery(this.checkoutWrapper).find("select[name=shippingState]");
					let inputField = jQuery(this.checkoutWrapper).find("input[name=shippingState]");
					pickerField.empty();

					if (response && response.result && response.result.length) {
						// Show select field
						pickerField.show()
						pickerField.parent().show()

						// Hide input field
						inputField.hide()
						inputField.parent().hide()
						inputField.val('')

						for (let state of response.result) {
							let option = jQuery("<option></option>")
								.attr("value", state.name).text(state.name)
							pickerField.append(option)
						}
					} else {
						// Hide select field
						pickerField.hide()
						pickerField.parent().hide()

						// Show input field
						inputField.show()
						inputField.parent().show()
					}
				});
			}
			// this.updateShippingMethod(optionSelected);
		});

	}

	setupGoogleAddress() {

		let element = document.getElementById("shippingStreet");

		if (!element) return;

		this.addressAutoComplete = new google.maps.places.Autocomplete(element);

		let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()
		let foundCountry = this.countries.find((c) => c && c.name == shippingCountry)

		if (foundCountry && foundCountry["alpha-2"]) {
			this.addressAutoComplete.setComponentRestrictions({
				'country': foundCountry["alpha-2"]
			})
		} else {
			this.addressAutoComplete.setComponentRestrictions({
				'country': ["US"]
			})
		}

		var googleListener = this.addressAutoComplete.addListener('place_changed', this.handleGoogleAddress.bind(this))
	}

	handleGoogleAddress() {
		var place = this.addressAutoComplete.getPlace()

		if (!place) return;

		var addressComponents = place["address_components"] || {}

		var city = this.findGoogleAddressPart(addressComponents, ['locality', 'sublocality', 'postal_town'], 'long_name') || ""
		var stateShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'short_name') || ""
		var stateLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'long_name') || ""
		var countyShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'short_name') || ""
		var countyLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'long_name') || ""
		var postcode = this.findGoogleAddressPart(addressComponents, 'postal_code', 'long_name') || ""
		var country = this.findGoogleAddressPart(addressComponents, 'country', 'long_name') || ""

		jQuery(this.checkoutWrapper).find("input[id='shippingCity']").val(city)

		var statePicker = jQuery('select[name="shippingState"]');
		var stateField = jQuery('input[name="shippingState"]');

		if (statePicker.length > 0 && statePicker.is('select')) {
			jQuery(statePicker).find("option").each(function() {
				this.selected = (this.text == stateLong);
			});
			if (jQuery(statePicker).data("select2")) {
				jQuery(statePicker).select2("data", {
					id: stateLong,
					text: stateShort
				})
				jQuery(statePicker).trigger('change')
			}
		} else if (stateField.length > 0) {
			stateField.val(stateShort)
		}

		jQuery(this.checkoutWrapper).find("input[id='shippingCounty']").val(countyShort || countyLong);
		jQuery(this.checkoutWrapper).find("input[id='shippingPostcode']").val(postcode);
		jQuery(this.checkoutWrapper).find("select[id='shippingCountry'] option").each(function() {
			this.selected = (this.text == country);
		});

		var subpremise = this.findGoogleAddressPart(addressComponents, 'subpremise', 'long_name') || ""
		var streetNumber = this.findGoogleAddressPart(addressComponents, 'street_number', 'long_name') || ""
		var street = this.findGoogleAddressPart(addressComponents, 'route', 'long_name') || ""

		var fullStreetNumber;
		if (subpremise && streetNumber) {
			fullStreetNumber = `${subpremise}/${streetNumber}`
		} else if (streetNumber) {
			fullStreetNumber = streetNumber
		}

		var line1 = "";

		if (fullStreetNumber && street) {
			line1 = `${fullStreetNumber} ${street}`
		} else if (street) {
			line1 = street
		}
		jQuery(this.checkoutWrapper).find("input[id='shippingStreet']").val(line1)

		this.formElement.valid()
	}

	findGoogleAddressPart(address_components, query, val = null) {
		for (let attr of address_components) {
			for (let type of attr.types) {
				if (Array.isArray(query) && query.filter(q => q == type).length > 0) {
					return val ? attr[val] : attr;
				} else if (type === query) {
					return val ? attr[val] : attr;
				}
			}
		}
		return null;
	}

	checkFormValid() {
		if (!this.formElement.valid()) {
			return false
		}

		return true;
	}

	updateSubmitButton(status) {
		jQuery("#submit-order").prop('disabled', status);
	}

	submitOrder() {
		if (this.isSubmitting) return;

		var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
		var submitButton = jQuery(this.checkoutWrapper).find("#submit-order")

		submitButton.addClass("loading")

		if (!this.checkFormValid()) {
			//TODO: Show form error;
			errorView.html("Please fill out the required form fields before submitting")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			return;
		}

		if (!this.paymentFormComplete) {
			errorView.html("Please fill out the required payment details before submitting")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			return
		}

		errorView.addClass("d-none")

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_run_total_check',
				params: {
					paymentIntent: this.paymentIntent,
					cart: this.cartId
				}
			}
		}).done((resC) => {

			let totalCheckRes = JSON.parse(resC);

			if (!totalCheckRes || !totalCheckRes.result) {
				console.log("its different")
				return
			}

			let eles = this.elements;

			this.stripe.confirmPayment({
				elements: eles,
				redirect: "if_required",
			}).then((result) => {
				if (result.error) {
					// Inform the customer that there was an error.
					console.error("Error", error)
					errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
					errorView.removeClass("d-none")
					submitButton.removeClass("loading")
					this.isSubmitting = false
					return;
				}

				let shippingFirstName = jQuery(this.checkoutWrapper).find('input[name="shippingFirstName"]').val()
				let shippingLastName = jQuery(this.checkoutWrapper).find('input[name="shippingLastName"]').val()
				let shippingCompany = jQuery(this.checkoutWrapper).find('input[name="shippingCompany"]').val()
				let shippingStreet = jQuery(this.checkoutWrapper).find('input[name="shippingStreet"]').val()
				let shippingCity = jQuery(this.checkoutWrapper).find('input[name="shippingCity"]').val()
				let shippingPickerState = jQuery(this.checkoutWrapper).find('select[name="shippingState"]').val()
				let shippingFieldState = jQuery(this.checkoutWrapper).find('input[name="shippingState"]').val()
				let shippingCounty = jQuery(this.checkoutWrapper).find('input[name="shippingCounty"]').val()
				let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()
				let shippingPostcode = jQuery(this.checkoutWrapper).find('input[name="shippingPostcode"]').val()
				let shippingEmail = jQuery(this.checkoutWrapper).find('input[name="shippingEmail"]').val()
				let shippingPhone = jQuery(this.checkoutWrapper).find('input[name="shippingPhone"]').val()

				let params = {
					cart: this.cartId,
					orderDetails: {
						shippingFirstName: shippingFirstName || null,
						shippingLastName: shippingLastName || null,
						shippingCompany: shippingCompany || null,
						shippingStreet: shippingStreet || null,
						shippingCity: shippingCity || null,
						shippingState: shippingPickerState || shippingFieldState || null,
						shippingCounty: shippingCounty || null,
						shippingCountry: shippingCountry || null,
						shippingPostcode: shippingPostcode || null,
						shippingEmail: shippingEmail || null,
						shippingPhone: shippingPhone || null
					},
					paymentIntent: this.paymentIntent || null
				};

				jQuery.ajax({
					method: 'post',
					url: ajax_var.url,
					data: {
						action: 'submit_order',
						params: params
					}
				}).done((res) => {
					if (res && res.result) {
						if (res.result.invoiceId) {
							window.location.replace(window.location.origin + "/confirmation?invoice=" + res.result.invoiceId);
						} else if (res.result.orderId) {
							window.location.replace(window.location.origin + "/confirmation?order=" + res.result.orderId);
						}
					}

					submitButton.removeClass("loading")
				}).fail((xhr, status, error) => {
					console.error("Error", error)
					errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
					errorView.removeClass("d-none")
					submitButton.removeClass("loading")
					this.isSubmitting = false
				})
			}).catch((error) => {
				console.error("Error", error)
				errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
				errorView.removeClass("d-none")
				submitButton.removeClass("loading")
				this.isSubmitting = false
			})
		}).fail((xhr, status, error) => {
			console.error("Error", error)
			errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			this.isSubmitting = false
		})
	}

	setupStripe() {
    this.loadingStripe = true
    if (!this.hasInitialStripe) {
      jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()
    }

		let testStripe = "pk_test_51HyO42F2bX2kTVtibwiGBRz0NODYQAkYYlr0eDT34Jle6i3AQZQ2Q9ClTf455EDVfatn9AvmQG3cbaKfDlmwputC00i1vFVPWD";
		let liveStripe = "pk_live_51HyO42F2bX2kTVtiLQbImMOe6VW5pIFd2mIRJ0SdYMvrSRa7BvaWvwr46hlOMP6GPPe0wX0oInJXLQkIcfBXMsPE00xgM7qEgI";

		let stripeKey = liveStripe;
		let customStripe = false;

		if (this.stripePublishableKey && this.stripePublishableKey.length) {
			stripeKey = this.stripePublishableKey;
			customStripe = true;
		}

		this.stripe = Stripe(stripeKey);

		let params = {
			customStripe: customStripe
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_intent',
				params: params
			}
		}).done((response) => {
			let paymentIntentRes = JSON.parse(response);
			if (paymentIntentRes && paymentIntentRes.result && paymentIntentRes.result.client_secret) {
				this.paymentIntent = paymentIntentRes.result;
				this.elements = this.stripe.elements({
					clientSecret: this.paymentIntent.client_secret,
				});

				this.paymentElement = this.elements.create('payment');
				this.paymentElement.mount('#fh-payment-details');

				this.paymentElement.on('change', (event) => {
					this.paymentFormComplete = event.complete
				});

        this.hasInitialStripe = true
        jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			}
      this.loadingStripe = false
		}).fail((xhr, status, error) => {
			console.log(status, error)
      this.loadingStripe = false
      jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
		})
	}

	updateShippingMethod(shippingMethod) {
		var params = {
			shippingMethod: shippingMethod
		};

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'update_shipping_method',
				params: params
			}
		}).done((response) => {
			var data = JSON.parse(response);
			if (data && data.result && data.result.cart) {
				let subtotal = data.result.cart.subtotal || 0
				let tax = data.result.cart.tax || 0
				let total = data.result.cart.total || 0
				let shipping = data.result.cart.shipping || 0
				jQuery(this.checkoutWrapper).find('#fh-cart-balance-shipping').html(shipping)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-subtotal').html(subtotal)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-tax').html(tax)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-total').html(total)
				this.setupStripe();
			}
		}).fail(() => {

		})
	}

	updatePaymentMethod(paymentMethod) {
		this.paymentMethod = paymentMethod
		if (paymentMethod == "firehawk-pay") {
			jQuery(this.checkoutWrapper).find(".firehawk-pay").show()
		} else {
			jQuery(this.checkoutWrapper).find(".firehawk-pay").hide()
		}
	}
}
